import { render, staticRenderFns } from "./bmap.vue?vue&type=template&id=b6f1f5f2&scoped=true"
import script from "./bmap.vue?vue&type=script&lang=js"
export * from "./bmap.vue?vue&type=script&lang=js"
import style0 from "./bmap.vue?vue&type=style&index=0&id=b6f1f5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f1f5f2",
  null
  
)

export default component.exports